export class ClosedCaptionManager {

	/**
	 * Current caption being displayed on screen
	 */
	public currentCaption: string;
	/**
	 * All active sound intervals. These intervals are used per sound to know when to update cc displayed on the screen
	 */
	public activeSoundIntervals: ActiveSoundInterval[] = [];

	private onForceUpdate: () => void;

	public get isPaused(): boolean {
		return this._isPaused;
	}
	private _isPaused: boolean = false;

	public pause() {
		this._isPaused = true;
		if (this.onForceUpdate) {
			this.onForceUpdate();
		}
	}

	public resume() {
		this._isPaused = false;
		if (this.onForceUpdate) {
			this.onForceUpdate();
		}
	}


	public stopAll() {
		for (var indx = this.activeSoundIntervals.length - 1; indx >= 0; indx--) {
			clearInterval(this.activeSoundIntervals[indx].interval);
		}

		this.activeSoundIntervals = [];
	}

	public loadVtt(path: string, id: string, onForceUpdate: () => void, offset?: number): void {
		this.onForceUpdate = onForceUpdate;
		var vttConfig: any = null;
		var context = this;
		$.get(path).then((result) => {
			context._convertVttToJson(result).then((r) => {
				var newInterval: ActiveSoundInterval = {
					id: id
				};
				vttConfig = r;
				var currentTime = offset ? offset : 0;
				newInterval.interval = setInterval(() => {
					if (context.isPaused) {
						return;
					}
					currentTime += 200;
					for (var indx = 0; indx < vttConfig.length; indx++) {
						if (
							vttConfig[indx].part &&
							!vttConfig[indx].done &&
							currentTime >= vttConfig[indx].start &&
							vttConfig[indx].part.trim() !== ''
						) {
							context.currentCaption = vttConfig[indx].part;
							console.log(context.currentCaption)
							if (onForceUpdate) {
								onForceUpdate();
							}
							vttConfig[indx].done = true;
							break;
						}
					}

					if (
						vttConfig.filter((item: any) => item.end < currentTime).length ===
						vttConfig.length
					) {
						clearInterval(newInterval.interval);
						context.currentCaption = null;
						console.log(context.currentCaption)
						if (onForceUpdate) {
							onForceUpdate();
						}
						// SoundManager.currentCaption = null;
					}
				}, 200);
				context.activeSoundIntervals.push(newInterval);
			});
		});
	}
	/**
	 * Converts the contents of a *.vtt file to json string
	 */
	private _convertVttToJson(vttString: string) {
		return new Promise((resolve, reject) => {
			var current: any = {};
			var sections: any = [];
			var start: any = false;
			var vttArray: any = vttString.split("\n");

			//remove all lines at the end of file that are empty
			for (var indx = vttArray.length - 1; indx >= 0; indx--) {
				if (vttArray[indx].trim() === '') {
					vttArray.splice(indx, 1);
				}
				else {
					break;
				}
			}
			for (var index = 0; index < vttArray.length; index++) {
				var line = vttArray[index];
				// if (line.replace(/<\/?[^>]+(>|$)/g, "") === " ") {
				// } else if (line.replace(/<\/?[^>]+(>|$)/g, "").trim() == "") {
				// } else if (line.indexOf("-->") !== -1) {
				if (line.indexOf("-->") !== -1) {
					start = true;

					if (current.start) {
						sections.push(this._clone(current));
					}

					current = {
						start: this._timeString2ms(
							line.split("-->")[0].trimRight().split(" ").pop()
						),
						end: this._timeString2ms(
							line.split("-->")[1].trimLeft().split(" ").shift()
						),
						part: "",
					};
					// } else if (line.replace(/<\/?[^>]+(>|$)/g, "").trim() === "") {
					// } else if (line.replace(/<\/?[^>]+(>|$)/g, "") === " ") {
				} else {
					if (start) {
						if (sections.length !== 0) {
							if (
								sections[sections.length - 1].part.replace(
									/<\/?[^>]+(>|$)/g,
									""
								) === line.replace(/<\/?[^>]+(>|$)/g, "")
							) {
							} else {
								if (current.part.length === 0) {
									current.part = line;
								} else {
									current.part = `${current.part} ${line}`;
								}
								// If it's the last line of the subtitles
								if (index === vttArray.length - 1) {
									sections.push(this._clone(current));
								}
							}
						} else {
							current.part = line;
							sections.push(this._clone(current));
							current.part = "";
						}
					}
				}
			}

			current = [];

			for (var indx = 0; indx < sections.length; indx++) {
				// sections[indx].part = sections[indx].part.replace(/<\/?[^>]+(>|$)/g, "");
			}

			resolve(sections);
		});
	}

	/**
	 * Clones an object
	 */
	private _clone(obj: any) {
		if (null == obj || "object" != typeof obj) return obj;
		var copy = obj.constructor();
		for (var attr in obj) {
			if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
		}
		return copy;
	}

	/**
	 * Converts a time string to milliseconds
	 */
	private _timeString2ms(a: any, b?: any) {
		return (
			(a = a.split(".")),
			(b = a[1] * 1 || 0),
			(a = a[0].split(":")),
			b +
			(a[2]
				? a[0] * 3600 + a[1] * 60 + a[2] * 1
				: a[1]
					? a[0] * 60 + a[1] * 1
					: a[0] * 1) *
			1e3
		);
	}
}


/**
 * Describes the interval used to display cc
 */
interface ActiveSoundInterval {

	/**
	 * The id of the interval instance
	 */
	id: string;

	/**
	 * The interval itself
	 */
	interval?: any;
}